// 自动获取焦点
export default {
  /**
   * 当被绑定的元素插入到 DOM 中时
   * 
   * @param el 元素
   */
  inserted: function(el) {
    // 聚焦元素
    el.focus()
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/directives/focus.js